import { ChangeDetectorRef, Component, ViewChild } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { FormsModule } from '@angular/forms';
import { RouterModule, ActivatedRoute, Router } from '@angular/router';
import { TFMService } from 'app/mock-api/tfm.service';
import { DestinationListType01Component } from '../../destination-list/destination-list-type01/destination-list-type01.component';
import { CurrencyPipe, NgClass } from '@angular/common';
import { FuseCardComponent } from '@fuse/components/card';
import { FooterType03Component } from "../../../../layout/common/footer/footer-type03/footer-type03.component";

@Component({
  selector: 'world-cruises-type01',
  standalone: true,
  imports: [MatIconModule, MatDatepickerModule, MatFormFieldModule, MatInputModule, FormsModule, RouterModule, DestinationListType01Component, CurrencyPipe, NgClass, FuseCardComponent, FooterType03Component],
  templateUrl: './world-cruises-type01.component.html',
  styleUrl: './world-cruises-type01.component.scss'
})
export class WorldCruisesType01Component {

  public view: any = {
   
  };

  constructor(private route: ActivatedRoute, private router: Router, private tfmService: TFMService, private _cd: ChangeDetectorRef) {
  }
}
